import type React from "react";

import { useGeneralStore } from "~/stores/use-general-store";
import { usePlatform } from "./use-platform";

export default function useSound() {
  const { buttonSoundEnabled } = useGeneralStore();
  const { platform } = usePlatform();
  const playSound = (audioRef: React.RefObject<HTMLAudioElement>) => {
    if (
      audioRef.current &&
      buttonSoundEnabled === false &&
      platform === "DESKTOP"
    ) {
      audioRef.current.src = "/click.mp3";
      audioRef.current.currentTime = 0;
      void audioRef.current.play();
    }
  };

  return {
    playSound,
  };
}
